var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6166 13.086H26.1514L17.021 6.58585V1.31822C17.021 0.658859 16.637 0.0803886 16.1159 0.0080699C15.4999 -0.0773762 14.9785 0.527035 14.9785 1.28449V6.58585L5.84824 13.086H2.38297C1.06686 13.086 0 14.4279 0 16.0832V32.3532C0 34.0085 1.06686 35.3504 2.38297 35.3504H29.6167C30.9327 35.3504 31.9997 34.0085 31.9997 32.3532V16.0832C31.9996 14.4279 30.9327 13.086 29.6166 13.086ZM15.9998 8.81075L22.005 13.0861H9.99462L15.9998 8.81075ZM29.9571 32.3532C29.9571 32.5897 29.8046 32.7814 29.6166 32.7814H2.38297C2.19497 32.7814 2.04254 32.5897 2.04254 32.3532V16.0832C2.04254 15.8467 2.19497 15.655 2.38297 15.655H29.6167C29.8047 15.655 29.9571 15.8467 29.9571 16.0832L29.9571 32.3532Z",
    fill: "#0086D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01058 19.6917C5.48953 19.7641 5.10547 20.3425 5.10547 21.0018V27.5011C5.10547 28.1604 5.48953 28.7389 6.01058 28.8112C6.62664 28.8967 7.14801 28.2922 7.14801 27.5348V20.968C7.14801 20.2106 6.62664 19.6062 6.01058 19.6917Z",
    fill: "#0086D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6151 19.6917C12.094 19.7641 11.71 20.3425 11.71 21.0018V27.5011C11.71 28.1604 12.094 28.7389 12.6151 28.8112C13.2311 28.8967 13.7525 28.2924 13.7525 27.5348V20.968C13.7525 20.2106 13.2311 19.6062 12.6151 19.6917Z",
    fill: "#0086D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1522 19.6917C18.6311 19.7641 18.2471 20.3425 18.2471 21.0018V27.5011C18.2471 28.1604 18.6311 28.7389 19.1522 28.8112C19.7682 28.8967 20.2896 28.2924 20.2896 27.5348V20.968C20.2896 20.2106 19.7682 19.6062 19.1522 19.6917Z",
    fill: "#0086D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7557 19.6917C25.2346 19.7641 24.8506 20.3425 24.8506 21.0018V27.5011C24.8506 28.1604 25.2346 28.7389 25.7557 28.8112C26.3718 28.8967 26.8931 28.2924 26.8931 27.5348V20.968C26.8931 20.2106 26.3718 19.6062 25.7557 19.6917Z",
    fill: "#0086D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalIcon);
export default __webpack_public_path__ + "static/media/terminalIcon.c88ae02dd5c8a7f2910a5cbf44d6fc36.svg";
export { ForwardRef as ReactComponent };